import React from 'react';
import { MdOutlineCancel } from 'react-icons/md';

const ExitRowDialog = ({ isOpen, onConfirm, onCancel, seatId }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div
        className="bg-white relative "
        style={{
          width: '926px',
          maxWidth: '926px',
          height: 'auto',
          position: 'fixed',
          fontSize: '14px',
          border: '1px solid #ebeff0',
          padding: '40px',
        }}
      >
        {/* Title Bar */}
        <div className="relative mb-5 mt-0 bg-white">
          {/* Close Button */}
          <button
            onClick={onCancel}
            className="absolute -right-6 -top-7 text-[#0078d2] hover:border-b-2 hover:border-[#0078d2] transition-colors"
            aria-label="Close dialog"
          >
            <MdOutlineCancel className="w-8 h-8 text-[#0078d2] font-thin" style={{ fontWeight: '100' }} />
          </button>

          {/* Dialog Title */}
          <h2
            className="float-left py-3 font-thin m-0 mb-3 text-[#00467f] whitespace-inherit overflow-visible focus:outline-[#b0d1e8]"
            style={{
              fontFamily: 'AmericanSansLight, Helvetica, Arial, sans-serif',
              fontSize: '30px',
              lineHeight: '36px',
              color: '#00467f'
            }}
          >
            Emergency exit seat requirements
          </h2>
        </div>

        {/* Dialog Content */}
        <div
          className="clear-both focus:outline-none"
          tabIndex={0}
          style={{
            outline: 'none'
          }}
          onFocus={(e) => {
            e.target.style.outline = '2px solid #b0d1e8';
          }}
          onBlur={(e) => {
            e.target.style.outline = 'none';
          }}
        >
          <div className="regularText mb-4">You chose a seat in an exit row.</div>
          <div className="regularText mb-4">To sit in an exit seat, government rules require that you are:</div>

          <ul className="list-none mb-6">
            <li className="flex items-start mb-2">
              <span className="text-[#d0dae0] mr-2">■</span>
              Willing to help in an evacuation
            </li>
            <li className="flex items-start mb-2">
              <span className="text-[#d0dae0] mr-2">■</span>
              Able to operate the exit door and help others exit
            </li>
            <li className="flex items-start mb-2">
              <span className="text-[#d0dae0] mr-2">■</span>
              Age 15 or older
            </li>
          </ul>

          <div className="regularText mb-4">You cannot sit in an exit seat if you:</div>

          <ul className="list-none mb-6">
            <li className="flex items-start mb-2">
              <span className="text-[#d0dae0] mr-2">■</span>
              Are traveling with a child under 15 or a passenger needing your help (seated anywhere on this flight)
            </li>
            <li className="flex items-start mb-2">
              <span className="text-[#d0dae0] mr-2">■</span>
              Need corrective aids beyond eyeglasses/contact lenses to see
            </li>
            <li className="flex items-start mb-2">
              <span className="text-[#d0dae0] mr-2">■</span>
              Require assistance beyond a hearing aid to hear and understand verbal instructions
            </li>
            <li className="flex items-start mb-2">
              <span className="text-[#d0dae0] mr-2">■</span>
              Cannot read exit instructions or understand crewmember instructions in English
            </li>
            <li className="flex items-start mb-2">
              <span className="text-[#d0dae0] mr-2">■</span>
              Have a condition that could prevent or injure you while helping in an evacuation
            </li>
          </ul>

          <div className="mt-6 mb-8">
            Do you accept the exit seat criteria?<br /><br />
            If not, please choose another seat.
          </div>


        </div>
        {/* Button Pane */}
        <div className="flex gap-4 justify-end">
          <button
            onClick={onCancel}
            style={{
              background: 'linear-gradient(#0078d2, #0061ab)',
              width: '236px'
            }}
            className="border-2 border-[#0078d2] text-white font-medium py-1.5 px-5 rounded transition-all text-base
             hover:underline"
            onMouseEnter={(e) => {
              e.target.style.background = 'linear-gradient(#0061ab, #00467f)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'linear-gradient(#0078d2, #0061ab)';
            }}
          >
            No
          </button>
          <button
            onClick={onConfirm}
            style={{
              background: 'linear-gradient(#0078d2, #0061ab)',
              width: '236px'
            }}
            className="text-white font-medium py-1.5 px-5 rounded transition-all text-base
             hover:underline"
            onMouseEnter={(e) => {
              e.target.style.background = 'linear-gradient(#0061ab, #00467f)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'linear-gradient(#0078d2, #0061ab)';
            }}
          > 
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExitRowDialog;